import { LoadingState } from 'mk2/reducers/loadingState';
import { PostsState } from './Comments.reducers';

export const getIds = (state: PostsState, key: string) => state[key] ? state[key].ids : [];
export const getIdsOrNull = (state: PostsState, key: string) => state[key] ? state[key].ids : null;
export const getLoadingState = (state: PostsState, key: string) => state[key] ? state[key].loadingState : LoadingState.INIT;
export const getErrorMessage = (state: PostsState, key: string) => state[key] && state[key].errorMessage;
export const getCanAdd = (state: PostsState, key: string) => state[key] ? state[key].canAdd : true;
